<template>
  <div class="content">
    <validation-observer ref="observer">
      <h2 class="page-title">個人設定</h2>

      <div class="section-wrapper">
        <section class="order-syaryo bg-gray p-1 p-md-2">
          <table class="table">
            <tr>
              <th>ID</th>
              <td>
                {{ account.USER_ID }}
              </td>
            </tr>
            <tr>
              <th>会社名</th>
              <td>
                {{ account.SOFU_SAKI_MEI }}
              </td>
            </tr>
            <tr v-if="isActivated">
              <th>
                現在のパスワード
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="パスワード"
                  v-slot="{ errors }"
                  :rules="`required|is:${pwd}`"
                >
                  <b-form-input
                    type="password"
                    v-model="account.PASSWORD"
                    ref="PASSWORD"
                    class="col-md-8"
                    maxlength="20"
                    :state="errors.length ? false : null"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
                <div class="ml-2 ml-md-4">
                  <span class="red col-md-8 kome">
                    お名前、パスワードを変更する際も現在のパスワードを入力してください
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                お名前
                <span class="must">必須</span>
              </th>
              <td>
                <div class="row ml-2">
                  <label class="mt-sm-2">姓</label>
                  <div class="col-md-4">
                    <validation-provider
                      name="TANTO_MEI_SEI"
                      v-slot="{ errors }"
                      rules="required|max:30|zenkaku|char"
                    >
                      <b-form-input
                        v-model="account.TANTO_MEI_SEI"
                        ref="TANTO_MEI_SEI"
                        maxlength="30"
                        :state="errors.length ? false : null"
                        placeholder="山田"
                        trim
                        @blur="
                          account.TANTO_MEI_SEI = replaceChar(
                            account.TANTO_MEI_SEI
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <label class="mt-2 ml-sm-4 mr-2">名</label>
                  <div class="col-md-4">
                    <validation-provider
                      name="TANTO_MEI"
                      v-slot="{ errors }"
                      rules="max:30|zenkaku|char"
                    >
                      <b-form-input
                        v-model="account.TANTO_MEI"
                        ref="TANTO_MEI"
                        maxlength="30"
                        :state="errors.length ? false : null"
                        placeholder="太郎"
                        trim
                        @blur="
                          account.TANTO_MEI = replaceChar(account.TANTO_MEI)
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                メールアドレス
                <span class="must">必須</span>
              </th>
              <td>
                <div class="row">
                  <div class="col-md-8">
                    <validation-provider
                      name="MAIL_ADDR"
                      v-slot="{ errors }"
                      rules="required|max:50|email"
                    >
                      <b-form-input
                        v-model="account.MAIL_ADDR"
                        ref="MAIL_ADDR"
                        maxlength="50"
                        :state="errors.length ? false : null"
                        placeholder="tanaka@mail.co.jp"
                        :disabled="isButtonDisabled"
                        trim
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <button
                    v-if="!isMobile"
                    type="button"
                    class="btn btn-success bold py-1 mb-1 sp-fs-14"
                    @click="isButtonDisabled = false"
                  >
                    編集
                  </button>
                  <div v-else class="text-right">
                    <button
                      type="button"
                      class="btn btn-success bold py-1 mt-2 sp-fs-14"
                      @click="isButtonDisabled = false"
                    >
                      編集
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="isActivated">
              <th>
                新しいパスワード
                <span v-if="isInputPW" class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="NEW_PASSWORD"
                  v-slot="{ errors }"
                  :rules="`${
                    isInputPW ? 'required|' : ''
                  }min:6|max:16|password`"
                >
                  <b-form-input
                    type="password"
                    v-model="account.NEW_PASSWORD"
                    ref="NEW_PASSWORD"
                    class="col-md-8"
                    maxlength="16"
                    :state="errors.length ? false : null"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr v-if="isActivated">
              <th>
                新しいパスワード（確認）
                <span v-if="isInputPW" class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  vid="CONFIRM"
                  name="パスワード"
                  v-slot="{ errors }"
                  :rules="`${
                    isInputPW ? 'required|' : ''
                  }|confirmed:NEW_PASSWORD|min:6|max:16`"
                >
                  <b-form-input
                    type="password"
                    v-model="account.CONFIRM"
                    ref="CONFIRM"
                    class="col-md-8"
                    maxlength="16"
                    :state="errors.length ? false : null"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr v-if="isActivated">
              <th>手配完了メールの配信</th>
              <td>
                <div class="ml-4 mt-2">
                  <md-checkbox
                    class="form-check-input md-primary"
                    v-model.number="account.TEHAI_KANRYO_MAIL"
                    :true-value="1"
                    :false-value="0"
                  >
                    希望する
                  </md-checkbox>
                </div>
              </td>
            </tr>
            <tr v-if="isActivated">
              <th>納車完了メールの配信</th>
              <td>
                <div class="ml-4 mt-2">
                  <div>
                    <md-checkbox
                      class="form-check-input md-primary mb-0 pos-relative"
                      v-model.number="account.NOSYA_KANRYO_MAIL"
                      :true-value="1"
                      :false-value="0"
                    >
                      希望する
                    </md-checkbox>
                  </div>
                  <div>
                    <div class="red col-md-8 kome f-size-12">
                      納車完了メールの配信について
                      <br />
                      ご依頼いただきました車輛が指定納車地に納車が完了したタイミングで、
                      <br />
                      ロジNAVIご登録のアドレス宛てにメールを送信いたします。
                      <br />
                      ※場合により実際の納車日よりも遅れて配信がある場合がございます。
                      <br />
                      予めご了承の上ご使用の程宜しくお願い致します。
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>

          <div class="text-right my-2 mr-3">
            <b-button
              class="btn-secondary sp-fs-14"
              @click="isDeleteConfirm = true"
            >
              削除
            </b-button>
            <md-dialog-confirm
              class="new"
              :md-fullscreen="false"
              @md-opened="scroll('locked')"
              @md-closed="scroll('clear')"
              :md-active.sync="isDeleteConfirm"
              md-title=""
              md-content="<strong>アカウントを削除してもよろしいですか？</strong>"
              md-confirm-text="はい"
              md-cancel-text="いいえ"
              @md-confirm="deleteAccount"
              @md-cancel="isDeleteConfirm = false"
            />
            <md-dialog-alert
              class="new"
              :md-fullscreen="false"
              @md-opened="scroll('locked')"
              @md-closed="scroll('clear')"
              :md-active.sync="isDeleted"
              md-content="<strong>アカウントを削除しました。</strong>"
            />
          </div>
        </section>
      </div>

      <div class="text-center mr-3 mr-md-0">
        <md-button
          type="button"
          class="btn-lg btn-secondary base-btn col-md-3 col-lg-2"
          :to="{ name: this.account.FROM_PAGE }"
        >
          もどる
        </md-button>
        <br v-if="isMobile" />
        <md-button
          type="button"
          class="btn-lg btn-success base-btn col-md-3 col-lg-2 md-raised"
          @click="saveAccount"
        >
          登録
        </md-button>

        <md-dialog-alert
          class="new"
          :md-fullscreen="false"
          @md-opened="scroll('locked')"
          @md-closed="scroll('clear')"
          :md-active.sync="isSent"
          md-content="<strong>メールアドレスは、変更したアドレス宛に送信される<br>アクティベートメール内のリンクがクリックされた時点で変更されます。</strong>"
        />

        <md-dialog-alert
          class="new"
          :md-fullscreen="false"
          @md-opened="scroll('locked')"
          @md-closed="scroll('clear')"
          :md-active.sync="isSaved"
          md-content="<strong>登録が完了しました。</strong>"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import Mixin from '../mixin/Mixin'
import Store from '@/store/index.js'
import Constant from '@/const'

export default {
  name: 'Account',
  components: {},
  mixins: [Mixin],
  data: () => ({
    account: {
      ID: '',
      USER_ID: '',
      STATUS: '',
      SOFU_SAKI_MEI: '',
      TANTO_MEI_SEI: '',
      TANTO_MEI: '',
      MAIL_ADDR: '',
      NEW_PASSWORD: '',
      PASSWORD: '',
      CONFIRM: '',
      DELETE_NICHIJI: '',
      FROM_PAGE: '',
      TEHAI_KANRYO_MAIL: 0,
      NOSYA_KANRYO_MAIL: 0,
    },
    isButtonDisabled: true,
    isSaved: false,
    isDeleteConfirm: false,
    isDeleted: false,
    isSent: false,

    /** オブザーバー */
    observer: null,

    /** 現在のPWD */
    pwd: null,
  }),

  methods: {
    getPWD() {
      return this.getAccountPW(this.account.ID).then((res) => {
        this.pwd = res.data.pw
      })
    },
    // ストア更新
    updateStore() {
      // 設定画面のストア更新
      const user = Store.state.setting.data
      user.TANTO_MEI_SEI = this.account.TANTO_MEI_SEI
      user.TANTO_MEI = this.account.TANTO_MEI
      user.MAIL_ADDR = this.account.MAIL_ADDR
      user.TEHAI_KANRYO_MAIL = this.account.TEHAI_KANRYO_MAIL
      user.NOSYA_KANRYO_MAIL = this.account.NOSYA_KANRYO_MAIL
      this.$store.commit('setting/create', user)
      // 自分のアカウントを更新した場合、userストアを更新
      if (this.isMydata) {
        let adminData = {}
        const user = Store.state.user.data
        if (user.ROLE === Constant.USER.ROLE.ADMIN_MEMBER) {
          adminData = {
            ROLE: user.ROLE,
            ADMIN_USER_ID: user.ADMIN_USER_ID,
            ADMIN_TANTO_ID: user.ADMIN_TANTO_ID,
          }
        }
        Store.dispatch('user/get')
          .then((res) => {
            // 代理ログイン中の場合は、管理者データを消失しないために更新
            if (adminData) {
              this.$store.commit('user/update', adminData)
            }
          })
          .catch((err) => {
            this._alert(err.message, false)
          })
      }
    },
    /**
     * アカウント登録
     */
    async saveAccount() {
      const valid = await this.observer.validate()
      if (!valid) return this._alert('入力項目にエラーがあります。')

      this.spinerOn()
      const user = JSON.parse(JSON.stringify(this.account))
      if (user.NEW_PASSWORD) {
        user.PASSWORD = user.NEW_PASSWORD
      }
      return this.$store
        .dispatch('account/updateAccount', user)
        .then(async (res) => {
          if (this.isActivated) await this.getPWD()
          if (
            !this.isButtonDisabled &&
            Store.state.setting.data.MAIL_ADDR !== user.MAIL_ADDR
          ) {
            this.isSent = true
          } else {
            this.isSaved = true
          }
          this.account.PASSWORD = ''
          this.account.NEW_PASSWORD = ''
          this.account.CONFIRM = ''
          if (this.isMydata)
            this.account.MAIL_ADDR = Store.state.setting.data.MAIL_ADDR
          this.isButtonDisabled = true
          this.updateStore()
          this.scroll('clear')
          this.observer.reset()
          this.spinerOff()
        })
        .catch((err) => {
          this.spinerOff()
          throw new Error(err.message)
        })
    },
    /**
     * アカウント削除
     */
    deleteAccount() {
      this.account.DELETE_NICHIJI = this.getNichiji()
      this.spinerOn()
      const url = this.isActivated
        ? 'account/updateAccount'
        : 'account/delAccount'
      return this.$store
        .dispatch(url, this.account)
        .then((res) => {
          this.observer.reset()
          this.spinerOff()
          // 自分のアカウントを削除する場合はログアウト
          if (this.isMydata) {
            this.logout()
          } else {
            this.$router.push({ name: 'SettingCompanyIndex' })
          }
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
  },
  computed: {
    isActivated() {
      return this.account.STATUS !== Constant.USER.STATUS.INITIAL
    },
    isInputPW() {
      return this.account.NEW_PASSWORD || this.account.CONFIRM
    },
    isMydata() {
      return Store.state.user.data.ID === this.account.ID
    },
  },

  mounted() {
    this.observer = this.$refs.observer
  },

  created() {
    const user = Store.state.setting.data
    this.account['ID'] = user.ID
    this.account['USER_ID'] = user.USER_ID
    this.account['STATUS'] = user.STATUS
    this.account['SOFU_SAKI_MEI'] = user.SOFU_SAKI_MEI
    this.account['TANTO_MEI_SEI'] = user.TANTO_MEI_SEI
    this.account['TANTO_MEI'] = user.TANTO_MEI
    this.account['TEHAI_KANRYO_MAIL'] = user.TEHAI_KANRYO_MAIL || 0
    this.account['NOSYA_KANRYO_MAIL'] = user.NOSYA_KANRYO_MAIL || 0
    this.account['MAIL_ADDR'] = user.MAIL_ADDR
    this.account['FROM_PAGE'] = user.FROM_PAGE
    if (this.isActivated) this.getPWD()
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
</style>



// WEBPACK FOOTER //
// src/components/setting/Edit.vue